import PubSub from "pubsub-js";
import Slick from "slick-carousel";
import Equalizer from "../../../../scripts/classes/Equalizer";
import loadTouchEvents from 'jquery-touch-events';
loadTouchEvents($);

var GalleryTwoUp = function(options) {

	this.options = {
		$el: false,
		baseClass: 'comp-GalleryTwoUp',
	};

	$.extend(true, this.options, options);

};

GalleryTwoUp.prototype.init = function() {

	var self = this

	// sliders
	this.$leftImageSlider = this.options.$el.find(`.${self.options.baseClass}__leftImageSlider`);
	this.$rightImageSlider = this.options.$el.find(`.${self.options.baseClass}__rightImageSlider`);

	// initialize image slider
	this.$leftImageSlider.slick({
		arrows: false,
		fade: false,
		infinite: true,
		speed: 750,
		swipe: false,
	});

	// initialize text slider
	this.$rightImageSlider.slick({
		arrows: false,
		fade: false,
		infinite: true,
		speed: 750,
		swipe: false,
	});

	// next image button
	this.options.$el.find(`.${self.options.baseClass}__nextImageButton`).on('click', function() {
		self.restartAutoplay();
		self.nextSlide();
	});

	// swipe events
	this.options.$el.on('swiperight', function() {
		self.restartAutoplay();
		self.previousSlide();
	});

	this.options.$el.on('swipeleft', function() {
		self.restartAutoplay();
		self.nextSlide();
	});

	// set up equalizer to set height of slide counter container because children are position: absolute
	this.slideCounterEq = new Equalizer( self.options.$el.find(`.${self.options.baseClass}__slideCounter__activeSlide, .${self.options.baseClass}__slideCounter__activeSlide__slideNumber`) );

	this.alignSlideCounter();

	$(window).on('load', function(){  
		self.alignSlideCounter();
	});

	PubSub.subscribe("resized", function(){
		self.alignSlideCounter();
	});

	this.$leftImageSlider.on('beforeChange', function(event, slick, currentSlide, nextSlide) {
	
		self.updateSlideCounter(nextSlide + 1);

	});

	// start autoplay
	this.sliderAutoplayInterval = window.setInterval(function() {
		self.nextSlide();
	}, 8000);

};

GalleryTwoUp.prototype.restartAutoplay = function() {

	var self = this;

	clearInterval(self.sliderAutoplayInterval);

	self.sliderAutoplayInterval = window.setInterval(function() {
		self.nextSlide();
	}, 8000);

};

GalleryTwoUp.prototype.updateSlideCounter = function(slideNumber){

	var self = this;

	this.options.$el.find(`.${self.options.baseClass}__slideCounter__activeSlide__slideNumber`).removeClass(`${self.options.baseClass}__slideCounter__activeSlide__slideNumber--active`);

	this.options.$el.find(`.${self.options.baseClass}__slideCounter__activeSlide__slideNumber` + '[data-slide-number="' + slideNumber + '"]').addClass(`${self.options.baseClass}__slideCounter__activeSlide__slideNumber--active`);

};

GalleryTwoUp.prototype.alignSlideCounter = function() {

	var self = this;

	

	this.slideCounterEq.equalizeHeights();
	this.slideCounterEq.equalizeWidths();

	/*

	this.maxWidth = 0;

	this.options.$el.find('.slide-number').each(function() {

		if ($(this).outerWidth() > self.maxWidth) {
			self.maxWidth = $(this).outerWidth();
		}

	});

	this.options.$el.find('.active-slide').css('width', self.maxWidth);

	// align the transformed numbers

	// get the difference between height and width of active slide container
	var activeSlideWidth = this.options.$el.find('.slide-counter .active-slide').width();
	var activeSlideHeight = this.options.$el.find('.slide-counter .active-slide').height();

	var widthHeightDiff = activeSlideWidth - activeSlideHeight;

	// since we're rotating the container, we need to adjust the top position
	// to account for the difference in width and height after rotation
	this.options.$el.find('.active-slide').css('transform', 'translateY(' + ((widthHeightDiff * -1) / 2) + 'px) rotate(90deg)');

	// get the difference between height and width of total slides container
	var totalSlidesWidth = this.options.$el.find('.slide-counter .total-slides').width();
	var totalSlidesHeight = this.options.$el.find('.slide-counter .total-slides').height();

	var totalSlidesWidthHeightDiff = totalSlidesWidth - totalSlidesHeight;

	// since we're rotating the container, we need to adjust the top position
	// to account for the difference in width and height after rotation
	this.options.$el.find('.slide-counter .total-slides').css('transform', 'translateY(' + ((totalSlidesWidthHeightDiff * -1) / 2) + 'px) rotate(90deg)');

	*/




	var $slideCounter = this.options.$el.find(`.${self.options.baseClass}__slideCounterWrapper`);
	var $contentWrapper = this.options.$el;

	var slideCounterHeight = $slideCounter.outerWidth(); // element is rotated via css so width is actually height
	var slideCounterWidth = $slideCounter.outerHeight(); // element is rotated via css so height is actually width

	var contentWrapperHeight = $contentWrapper.outerHeight();
	var contentWrapperWidth = $contentWrapper.width();

	console.log('align');
	console.log( slideCounterHeight );

	$slideCounter.css('transform', 'translateX(' + slideCounterHeight + 'px) rotate(90deg)' );


	/*
	// top
	var newTop = (contentWrapperHeight / 2) - (slideCounterHeight / 2);
	$slideCounter.css('top', newTop);

	// right
	// pull right by negative height to align with right edge, then move away by 3.5% width
	// pulling right by negative height aligns with right edge because we're using transform-origin: 0px 0px
	// which means we pull right by negative height (which is width before our transform), and then
	// we swing the item down 90 degrees by it's top left edge
	var newRight = (slideCounterHeight * -1) + (contentWrapperWidth * 0.035); 
	$slideCounter.css('right', newRight);
	*/

	


};

GalleryTwoUp.prototype.nextSlide = function() {
	this.$leftImageSlider.slick('slickNext');
	this.$rightImageSlider.slick('slickNext');
};

GalleryTwoUp.prototype.previousSlide = function() {
	this.$leftImageSlider.slick('slickPrev');
	this.$rightImageSlider.slick('slickPrev');
};

export default GalleryTwoUp;
